import { ref, onMounted } from 'vue';

const globalEnterTime = ref();

export function usePageTime() {
  onMounted(() => {
    globalEnterTime.value = new Date();
  });

  return {
    enterTime: globalEnterTime,
  };
}
